<div class="side-nav-content" *ngIf="sideNavOpen">
  <div class="nav-list">
    <app-sidenav-item
      *ngFor="let item of navList"
      [item]="item"
      (navigationComplete)="navigationCompleted.emit()"
    ></app-sidenav-item>
  </div>
</div>
